import React from 'react';
//@ts-ignore
import * as cardStyles from './cards.module.css';
import { RelatedProductsProps } from './index';
import ProductTile from './ProductTile';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';
import { getColor, getMultiChoice } from '../Global/DataUtils';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

interface Props extends RelatedProductsProps {
    selectedProducts: ProductPagePreview[];
    productCtaLabel?: string;
    customCtaLink?: string;
    useCustomCtaLocation?: boolean;
    mobile_view?: any;
}

const Cards: React.FC<Props> = ({
    selectedProducts,
    background_color,
    useCustomCtaLocation,
    customCtaLink,
    content_panel__content_panel_color,
    content_panel__content_panel_font_color,
    mobile_view,
    ...props
}) => {
    const breakpoints = useBreakpoint();
    const isMobileViewStack =
        getMultiChoice(mobile_view) === 'stacked' && !breakpoints.md;
    if (selectedProducts?.length === 0) return null;

    return (
        <div className={cardStyles.cardsContainer}>
            {selectedProducts?.map((product, idx) => {
                const productStyle =
                    (selectedProducts?.length % 2 === 1 &&
                        (idx + 1) % 3 === 0) ||
                    selectedProducts?.length === 1
                        ? `${cardStyles.product} ${cardStyles.wideProduct}`
                        : cardStyles.product;

                return (
                    <ProductTile
                        key={idx}
                        product={product}
                        productCtaLabel={
                            props.product_cta_label?.value || 'View Product'
                        }
                        backgroundColor={
                            isMobileViewStack
                                ? 'var(--color-gray)'
                                : getColor(background_color) || undefined
                        }
                        fontColor={
                            isMobileViewStack
                                ? '#373f49'
                                : getColor(
                                      content_panel__content_panel_font_color
                                  ) || undefined
                        }
                        truncateLines={3}
                        productStyle={productStyle}
                        ctaStyle={`${
                            isMobileViewStack ? cardStyles.stackedctaStyles : ''
                        } ${cardStyles.ctaContainer}`}
                        useCustomCtaLocation={useCustomCtaLocation}
                        customCtaLink={customCtaLink}
                    />
                );
            })}
        </div>
    );
};

export default Cards;
